import { render, staticRenderFns } from "./definition-a-b-testing.vue?vue&type=template&id=68134f2a&"
import script from "./definition-a-b-testing.vue?vue&type=script&lang=js&"
export * from "./definition-a-b-testing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports